module.exports = __webpack_public_path__ + "img/england.10c43bfb.png";